import { useNavigate } from "react-router-dom";
import Button from "../../../../../components/world/rmc/Button";
import { FullModal } from "../fullModal";
import { useContext } from "react";
import { RmcContext } from "../../../../../components/context/RmcContext";

export const RewardSuccess = () => {
  const navigate = useNavigate();
  const { slug } = useContext(RmcContext);
  return (
    <FullModal>
      <div className="text-center mb-6 px-4 pt-16 overflow-y-scroll hidden-scrollbar">
        <div className="flex items-center gap-5 flex-col">
          <Check />
          <div>
            <p className="mb-2 text-center text-2xl text-white font-semibold">
              Congratulations!
            </p>
            <p className="max-w-[241px] text-xs font-medium leading-tight text-center">
              Your reward claim is being processed. You’ll receive a
              confirmation soon through our agent.
            </p>
          </div>

          <div className="w-full flex flex-col gap-5 mt-10">
            <Button
              onClick={() =>
                navigate(`/worlds/${slug}/achievements?tab=rewards`)
              }
              text="Back to Rewards"
              className="text-lg py-[18px]"
            />
            <Button
              onClick={() =>
                navigate(
                  `/worlds/${slug}/achievements/rewards/tracking?status=pending`
                )
              }
              text="Track My Reward Status"
              className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
            />
          </div>
        </div>
      </div>
    </FullModal>
  );
};

const Check = () => {
  return (
    <svg
      width="67"
      height="68"
      viewBox="0 0 67 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4993 67.3332C15.0893 67.3332 0.166016 52.4098 0.166016 33.9998C0.166016 15.5898 15.0893 0.666504 33.4993 0.666504C51.9093 0.666504 66.8327 15.5898 66.8327 33.9998C66.8327 52.4098 51.9093 67.3332 33.4993 67.3332ZM29.576 41.1332L20.3593 31.9098L16.8327 35.4365L27.2293 45.8398C27.8544 46.4647 28.7021 46.8158 29.586 46.8158C30.4699 46.8158 31.3176 46.4647 31.9427 45.8398L51.7827 26.0065L48.2427 22.4665L29.576 41.1332Z"
        fill="#FFD700"
      />
    </svg>
  );
};
